/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NGXS_PLUGINS } from '@ngxs/store';
import { NGXS_RESET_PLUGIN_OPTIONS, NgxsResetPlugin } from './ngxs-reset.plugin';
import { NgxsResetPluginOptions } from './ngxs-reset.model';

@NgModule()
export class NgxsResetPluginModule {
    static forRoot(config: NgxsResetPluginOptions): ModuleWithProviders<NgxsResetPluginModule> {
        return {
            ngModule: NgxsResetPluginModule,
            providers: [{
                provide: NGXS_PLUGINS,
                useClass: NgxsResetPlugin,
                multi: true
            }, {
                provide: NGXS_RESET_PLUGIN_OPTIONS,
                useValue: config,
            }]
        };
    }
}
